import { render, staticRenderFns } from "./CompTabelaCdaExcluida.vue?vue&type=template&id=227daab8&"
import script from "./CompTabelaCdaExcluida.vue?vue&type=script&lang=js&"
export * from "./CompTabelaCdaExcluida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports